var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.content),expression:"content"}],staticClass:"tooltip",class:( _obj = {}, _obj['tooltip--text-link'] = _vm.isTextLink, _obj )},[_vm._t("default",function(){return [_c('dotcom-icon',{staticClass:"tooltip__icon",attrs:{"name":"circle-info","art":"light","color":"--c-primary-color-3","hover-color":"--c-tint-color-1"}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }